import { inject, Injectable } from '@angular/core';
import { BaseSynchronizeService } from "@core/services/synchronize/synchronize.service";
import { WorkTimeEntryRequest, WorkTimeEntryService } from "@api/api";
import { WorkTimeEntryIndexedDbService } from "@core/storage/indexedDb/work-time-entry-database.service";

/**
 * Extra munkaidő-tételek feltöltése (E1.5).
 *
 * Az idempotenciát a `clientUuid` adja: a szerver oldali unique constraint miatt az
 * újrapróbálkozás nem hoz létre duplikátumot, hanem a már meglévő tételt adja vissza.
 */
@Injectable({
  providedIn: 'root',
})
export class WorkTimeEntrySynchronizeService extends BaseSynchronizeService<WorkTimeEntryRequest> {
  database = inject(WorkTimeEntryIndexedDbService);
  workTimeEntryService = inject(WorkTimeEntryService);
  apiFunction = (data: WorkTimeEntryRequest) => {
    return this.workTimeEntryService.createWorkTimeEntry(data);
  };
}
